import React from 'react';

import asReduxFormField from '@common/components/FormElements/asReduxFormField';
import CommonQuantityPicker from '@common/components/QuantityPicker';
import { QuantityPickerWrapper, QuantityPickerLabel } from './QuantityPicker.styles';

export const QuantityPicker = asReduxFormField((props) => (
  <QuantityPickerWrapper>
    <QuantityPickerLabel>{props.placeholder}</QuantityPickerLabel>
    <CommonQuantityPicker {...props} input={{ value: props.value, onChange: props.onChange }} />
  </QuantityPickerWrapper>
));
